import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    id: 'controlador',
    icon: 'ri-building-line',
    title: '1. Identificação do Controlador de Dados',
    content: `A <strong>MG+ Saúde &amp; Estética</strong>, pessoa jurídica com sede na Rua Primeiro de Maio, 202, Sala 601, Centro, Santo André – SP, é a controladora dos dados pessoais coletados por meio desta clínica e dos canais digitais a ela vinculados.

Para exercer seus direitos ou esclarecer dúvidas sobre o tratamento de dados, entre em contato com nosso Encarregado de Dados (DPO) pelo e-mail <strong>contato@mgsaudeoral.com.br</strong> ou pelo telefone <strong>(11) 2228-9498</strong>. Site: <a href="https://mgsaudeoral.com.br" target="_blank" rel="noopener noreferrer" class="text-[#C4A45A] hover:underline">mgsaudeoral.com.br</a>`,
  },
  {
    id: 'dados-coletados',
    icon: 'ri-file-list-3-line',
    title: '2. Dados Pessoais Coletados',
    content: `No contexto de uma clínica de <strong>estética e ortodontia</strong>, coletamos as seguintes categorias de dados:

<ul class="list-disc pl-5 mt-3 space-y-2">
  <li><strong>Dados de identificação:</strong> nome completo, CPF, RG, data de nascimento, gênero.</li>
  <li><strong>Dados de contato:</strong> telefone, endereço, e-mail e perfis em aplicativos de mensagem (ex.: WhatsApp).</li>
  <li><strong>Dados de saúde (dados sensíveis):</strong> histórico médico e odontológico, anamnese, radiografias, fotos intraorais e faciais, laudos e prescrições, informações sobre alergias, medicamentos em uso e condições preexistentes.</li>
  <li><strong>Dados estéticos:</strong> fotografias e vídeos para avaliação e acompanhamento de procedimentos estéticos faciais e corporais.</li>
  <li><strong>Dados financeiros:</strong> informações de pagamento, plano de saúde ou odontológico (quando aplicável), histórico de parcelas e recibos.</li>
  <li><strong>Dados de navegação:</strong> endereço IP, cookies, dados de acesso ao site e formulários de contato online.</li>
</ul>`,
  },
  {
    id: 'finalidade',
    icon: 'ri-focus-3-line',
    title: '3. Finalidade do Tratamento',
    content: `Os dados pessoais são tratados para as seguintes finalidades:

<ul class="list-disc pl-5 mt-3 space-y-2">
  <li>Agendamento, confirmação e gerenciamento de consultas e procedimentos;</li>
  <li>Elaboração de anamnese, prontuário clínico e acompanhamento do tratamento;</li>
  <li>Documentação fotográfica antes, durante e após procedimentos estéticos e ortodônticos para fins clínicos e de controle de qualidade;</li>
  <li>Emissão de recibos, notas fiscais, contratos de prestação de serviços e cobranças;</li>
  <li>Comunicação de retornos, lembretes de agendamentos e informações sobre o tratamento;</li>
  <li>Envio de comunicações de marketing, promoções e novidades (somente com consentimento prévio);</li>
  <li>Cumprimento de obrigações legais e regulatórias, incluindo o Código de Ética Odontológica (CFO) e normativas do CRO;</li>
  <li>Melhoria contínua dos serviços e experiências oferecidas pela clínica.</li>
</ul>`,
  },
  {
    id: 'base-legal',
    icon: 'ri-scales-3-line',
    title: '4. Base Legal para o Tratamento',
    content: `O tratamento dos dados coletados pela MG+ Saúde &amp; Estética é fundamentado nas seguintes hipóteses previstas na Lei nº 13.709/2018 (LGPD):

<ul class="list-disc pl-5 mt-3 space-y-2">
  <li><strong>Consentimento (art. 7º, I):</strong> para envio de comunicações de marketing, uso de imagens em redes sociais e fins que ultrapassem o escopo do tratamento clínico.</li>
  <li><strong>Execução de contrato (art. 7º, V):</strong> para realização dos procedimentos estéticos e ortodônticos contratados e cobrança pelos serviços prestados.</li>
  <li><strong>Cumprimento de obrigação legal (art. 7º, II):</strong> para atendimento às normas do CFO/CRO, ANVISA e demais órgãos reguladores da área da saúde.</li>
  <li><strong>Tutela da saúde (art. 11, II, f):</strong> para tratamento de dados sensíveis de saúde indispensáveis à realização de diagnósticos, prescrições e acompanhamento clínico.</li>
  <li><strong>Legítimo interesse (art. 7º, IX):</strong> para prevenção de fraudes, segurança da informação e melhoria dos serviços.</li>
</ul>`,
  },
  {
    id: 'compartilhamento',
    icon: 'ri-share-line',
    title: '5. Compartilhamento de Dados',
    content: `Os dados pessoais dos titulares podem ser compartilhados nas seguintes situações:

<ul class="list-disc pl-5 mt-3 space-y-2">
  <li><strong>Profissionais parceiros:</strong> médicos, ortodontistas, estetas e especialistas envolvidos no cuidado do paciente, sempre em caráter necessário e sob sigilo profissional.</li>
  <li><strong>Laboratórios e fornecedores:</strong> laboratórios de prótese, distribuidores de materiais e outros fornecedores necessários à execução do tratamento.</li>
  <li><strong>Plataformas de agendamento e gestão:</strong> softwares de prontuário eletrônico, gestão clínica e comunicação, que atuam como operadores de dados sob contrato de confidencialidade.</li>
  <li><strong>Autoridades competentes:</strong> em cumprimento de obrigação legal ou por determinação judicial, mediante o mínimo de dados necessário.</li>
</ul>

A MG+ Saúde &amp; Estética <strong>não vende, aluga ou cede</strong> dados pessoais a terceiros para fins comerciais não relacionados ao tratamento clínico.`,
  },
  {
    id: 'retencao',
    icon: 'ri-time-line',
    title: '6. Retenção e Exclusão dos Dados',
    content: `Os dados são conservados pelo período necessário para cumprimento das finalidades que motivaram sua coleta, observando-se:

<ul class="list-disc pl-5 mt-3 space-y-2">
  <li><strong>Prontuários odontológicos:</strong> mínimo de 20 anos após a última consulta, conforme o Código de Ética Odontológica (Resolução CFO-118/2012).</li>
  <li><strong>Prontuários de estética:</strong> mínimo de 5 anos, podendo ser estendido para fins de defesa em processos administrativos ou judiciais.</li>
  <li><strong>Dados financeiros e fiscais:</strong> 5 anos, em atendimento à legislação tributária.</li>
  <li><strong>Dados de marketing (consentimento):</strong> até a revogação do consentimento pelo titular.</li>
  <li><strong>Dados de navegação:</strong> até 6 meses, salvo necessidade legal específica.</li>
</ul>

Após o término do prazo, os dados serão anonimizados ou eliminados de forma segura.`,
  },
  {
    id: 'direitos',
    icon: 'ri-shield-user-line',
    title: '7. Direitos do Titular',
    content: `De acordo com o art. 18 da LGPD, você tem os seguintes direitos em relação aos seus dados pessoais:

<ul class="list-disc pl-5 mt-3 space-y-2">
  <li><strong>Acesso:</strong> saber quais dados seus estão sendo tratados;</li>
  <li><strong>Correção:</strong> corrigir dados incompletos, inexatos ou desatualizados;</li>
  <li><strong>Anonimização, bloqueio ou eliminação:</strong> de dados desnecessários, excessivos ou tratados em desconformidade com a LGPD;</li>
  <li><strong>Portabilidade:</strong> receber seus dados em formato estruturado e interoperável;</li>
  <li><strong>Eliminação:</strong> solicitar a exclusão dos dados tratados com base no consentimento;</li>
  <li><strong>Informação:</strong> ser informado sobre com quem seus dados são compartilhados;</li>
  <li><strong>Revogação do consentimento:</strong> retirar o consentimento a qualquer momento, sem prejuízo à prestação dos serviços clínicos essenciais;</li>
  <li><strong>Oposição:</strong> opor-se a tratamento realizado com base em outra hipótese legal, em caso de descumprimento.</li>
</ul>

Para exercer qualquer desses direitos, entre em contato com nosso DPO pelo e-mail <strong>contato@mgsaudeoral.com.br</strong>.`,
  },
  {
    id: 'seguranca',
    icon: 'ri-lock-line',
    title: '8. Segurança dos Dados',
    content: `Adotamos medidas técnicas e organizacionais adequadas para proteger os dados pessoais contra acesso não autorizado, perda, destruição, alteração ou divulgação indevida, incluindo:

<ul class="list-disc pl-5 mt-3 space-y-2">
  <li>Controle de acesso baseado em perfis (somente profissionais autorizados acessam prontuários);</li>
  <li>Uso de sistemas de gestão clínica com criptografia de dados e comunicação segura (HTTPS);</li>
  <li>Treinamento periódico da equipe em boas práticas de proteção de dados e sigilo profissional;</li>
  <li>Política de descarte seguro de documentos físicos contendo dados sensíveis;</li>
  <li>Monitoramento de acessos e revisão periódica dos controles de segurança.</li>
</ul>

Em caso de incidente de segurança que possa acarretar risco ou dano relevante aos titulares, a MG+ Saúde &amp; Estética comunicará a ocorrência à Autoridade Nacional de Proteção de Dados (ANPD) e, quando necessário, aos próprios titulares, no prazo legalmente previsto.`,
  },
  {
    id: 'cookies',
    icon: 'ri-code-s-slash-line',
    title: '9. Cookies e Tecnologias de Rastreamento',
    content: `Nosso site utiliza cookies e tecnologias similares para melhorar a experiência de navegação, analisar tráfego e personalizar conteúdo. Os tipos de cookies utilizados são:

<ul class="list-disc pl-5 mt-3 space-y-2">
  <li><strong>Cookies essenciais:</strong> necessários para o funcionamento básico do site; não podem ser desativados.</li>
  <li><strong>Cookies analíticos:</strong> coletam dados anônimos sobre como os visitantes utilizam o site (ex.: Google Analytics), com finalidade de melhoria do serviço.</li>
  <li><strong>Cookies de marketing:</strong> utilizados para exibir anúncios relevantes em plataformas como Google e Instagram, somente com seu consentimento.</li>
</ul>

Você pode gerenciar suas preferências de cookies diretamente nas configurações do seu navegador. A recusa de cookies não essenciais não compromete o acesso ao site.`,
  },
  {
    id: 'imagens',
    icon: 'ri-camera-line',
    title: '10. Uso de Imagens e Registros Fotográficos',
    content: `Dado o caráter visual dos tratamentos estéticos e ortodônticos, a coleta de imagens fotográficas e/ou vídeos do paciente é parte essencial do protocolo clínico. Tais registros são utilizados para:

<ul class="list-disc pl-5 mt-3 space-y-2">
  <li>Documentação do prontuário clínico (uso interno e obrigatório);</li>
  <li>Acompanhamento da evolução do tratamento;</li>
  <li>Fins científicos e educacionais, somente mediante autorização específica por escrito;</li>
  <li>Divulgação em redes sociais ou materiais publicitários, somente mediante Termo de Autorização de Uso de Imagem devidamente assinado pelo titular.</li>
</ul>

O paciente pode revogar a autorização de uso de imagem para fins de marketing a qualquer momento, sem que isso afete o tratamento clínico.`,
  },
  {
    id: 'atualizacoes',
    icon: 'ri-refresh-line',
    title: '11. Atualizações desta Política',
    content: `Esta Política de Privacidade pode ser atualizada periodicamente para refletir alterações nas práticas de tratamento de dados, mudanças legais ou melhorias nos serviços. A versão mais recente estará sempre disponível nesta página, com a data da última atualização indicada ao final do documento.

Recomendamos a leitura periódica desta política. Em caso de alterações significativas, comunicaremos os titulares pelos canais de contato cadastrados.`,
  },
  {
    id: 'contato-dpo',
    icon: 'ri-customer-service-2-line',
    title: '12. Contato – Encarregado de Dados (DPO)',
    content: `Para solicitações, dúvidas ou reclamações relacionadas ao tratamento de dados pessoais, entre em contato com o Encarregado de Proteção de Dados da MG+ Saúde &amp; Estética:

<ul class="list-none mt-3 space-y-2">
  <li><i class="ri-mail-line text-[#C4A45A] mr-2"></i><strong>E-mail:</strong> contato@mgsaudeoral.com.br</li>
  <li><i class="ri-global-line text-[#C4A45A] mr-2"></i><strong>Site:</strong> <a href="https://mgsaudeoral.com.br" target="_blank" rel="noopener noreferrer" class="text-[#C4A45A] hover:underline">mgsaudeoral.com.br</a></li>
  <li><i class="ri-phone-line text-[#C4A45A] mr-2"></i><strong>Telefone:</strong> (11) 2228-9498</li>
  <li><i class="ri-map-pin-line text-[#C4A45A] mr-2"></i><strong>Endereço:</strong> Rua Primeiro de Maio, 202, Sala 601, Centro, Santo André – SP, CEP 09020-170</li>
</ul>

Caso não obtenha resposta satisfatória, você poderá contatar a <strong>Autoridade Nacional de Proteção de Dados (ANPD)</strong> em <a href="https://www.gov.br/anpd" target="_blank" rel="noopener noreferrer nofollow" class="text-[#C4A45A] hover:underline">www.gov.br/anpd</a>.`,
  },
];

const LgpdPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="min-h-screen bg-white font-raleway">
      {/* React 19 Document Metadata – SEO da página LGPD */}
      <title>Política de Privacidade LGPD | MG+ Saúde Oral – Santo André SP</title>
      <meta name="description" content="Política de Privacidade e LGPD da MG+ Saúde Oral, clínica de estética e ortodontia em Santo André, SP. Saiba como tratamos seus dados pessoais com segurança e transparência." />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://mgsaudeoral.com.br/lgpd" />
      <meta property="og:title" content="Política de Privacidade LGPD | MG+ Saúde Oral – Santo André SP" />
      <meta property="og:description" content="Política de Privacidade da MG+ Saúde Oral. Clínica de estética e ortodontia em Santo André, SP. Tratamento de dados em conformidade com a Lei 13.709/2018." />
      <meta property="og:url" content="https://mgsaudeoral.com.br/lgpd" />
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Política de Privacidade LGPD – MG+ Saúde Oral",
        "url": "https://mgsaudeoral.com.br/lgpd",
        "description": "Política de Privacidade da MG+ Saúde Oral, clínica de estética e ortodontia em Santo André SP, em conformidade com a LGPD (Lei 13.709/2018).",
        "inLanguage": "pt-BR",
        "isPartOf": {"@id": "https://mgsaudeoral.com.br/#website"},
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {"@type": "ListItem", "position": 1, "name": "Início", "item": "https://mgsaudeoral.com.br/"},
            {"@type": "ListItem", "position": 2, "name": "Política de Privacidade", "item": "https://mgsaudeoral.com.br/lgpd"}
          ]
        }
      })}</script>

      {/* Top Bar */}
      <header className="bg-[#2C2B29] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="font-cormorant text-2xl md:text-3xl font-semibold tracking-widest text-white">
              MG<span className="text-[#C4A45A]">+</span>
            </span>
            <span className="hidden sm:block text-xs tracking-[0.25em] uppercase font-raleway font-light text-white/70">
              Saúde &amp; Estética
            </span>
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-xs tracking-[0.12em] uppercase font-raleway text-white/70 hover:text-[#C4A45A] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Voltar ao site
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-[#F5F0E8] border-b border-[#E8E0D6] py-14 md:py-20">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#C4A45A]/10 border border-[#C4A45A]/30 mx-auto mb-5">
            <i className="ri-shield-check-line text-2xl text-[#C4A45A]"></i>
          </div>
          <h1 className="font-cormorant text-4xl md:text-5xl text-[#2C2B29] font-semibold tracking-wide mb-4">
            Política de Privacidade
            <span className="block text-[#C4A45A] text-2xl md:text-3xl font-light mt-1">LGPD – Lei Geral de Proteção de Dados</span>
          </h1>
          <p className="font-raleway text-sm md:text-base text-[#8B8680] leading-relaxed max-w-2xl mx-auto mt-4">
            A MG+ Saúde &amp; Estética está comprometida com a transparência no tratamento de dados pessoais de seus pacientes e visitantes, em conformidade com a <strong className="text-[#6B6560]">Lei nº 13.709/2018</strong> (LGPD) e as normas éticas do setor de saúde e estética.
          </p>
          <p className="font-raleway text-xs text-[#B0A89E] mt-5">
            Última atualização: <strong>31 de março de 2026</strong>
          </p>
        </div>
      </section>

      {/* Index */}
      <section className="border-b border-[#E8E0D6] bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 py-8">
          <p className="text-xs tracking-[0.2em] uppercase font-raleway text-[#C4A45A] font-semibold mb-4">Sumário</p>
          <ol className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
            {sections.map((s, idx) => (
              <li key={s.id}>
                <a
                  href={`#${s.id}`}
                  className="font-raleway text-sm text-[#6B6560] hover:text-[#C4A45A] transition-colors cursor-pointer flex items-center gap-2"
                >
                  <span className="text-[#C4A45A] font-semibold text-xs w-4">{idx + 1}.</span>
                  {s.title.replace(/^\d+\.\s/, '')}
                </a>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col gap-10">
          {sections.map((section) => (
            <article
              key={section.id}
              id={section.id}
              className="bg-[#FDFCFA] border border-[#EDE7DB] rounded-lg p-6 md:p-8 scroll-mt-6"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#C4A45A]/10 border border-[#C4A45A]/20 shrink-0 mt-0.5">
                  <i className={`${section.icon} text-[#C4A45A] text-base`}></i>
                </div>
                <h2 className="font-cormorant text-xl md:text-2xl text-[#2C2B29] font-semibold leading-snug">
                  {section.title}
                </h2>
              </div>
              <div
                className="font-raleway text-sm text-[#6B6560] leading-relaxed pl-0 md:pl-14"
                dangerouslySetInnerHTML={{ __html: section.content }}
              />
            </article>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-12 border-t border-[#E8E0D6] pt-8 text-center">
          <p className="font-raleway text-xs text-[#B0A89E] leading-relaxed max-w-xl mx-auto">
            Esta política foi elaborada em conformidade com a <strong className="text-[#8B8680]">Lei nº 13.709/2018 (LGPD)</strong>, o <strong className="text-[#8B8680]">Código de Ética Odontológica (CFO)</strong> e as resoluções da <strong className="text-[#8B8680]">ANVISA</strong> aplicáveis ao setor de saúde e estética.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 bg-[#C4A45A] text-white text-xs tracking-[0.15em] uppercase font-raleway font-medium px-6 py-3 rounded-full hover:bg-[#B8975A] transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Voltar à página inicial
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#F5F0E8] border-t border-[#E8E0D6]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="font-raleway text-xs text-[#B0A89E] text-center sm:text-left">
            © {new Date().getFullYear()} MG+ Saúde &amp; Estética. Todos os direitos reservados.
          </p>
          <a
            href="https://www.ovoscomweb.com.br"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="font-raleway text-xs text-[#B0A89E] hover:text-[#C4A45A] transition-colors cursor-pointer whitespace-nowrap"
          >
            by OvosComWeb
          </a>
        </div>
      </footer>
    </div>
  );
};

export default LgpdPage;
